var render, staticRenderFns
import script from "./FIleInput.vue?vue&type=script&lang=js"
export * from "./FIleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce201f32",
  null
  
)

export default component.exports